module.exports = __webpack_public_path__ + "img/Image_08.045d7257.jpg";